import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VisualsReducer } from '.';

export const featureSelector = createFeatureSelector<VisualsReducer.State>('pivotStudio.visuals');

export const isLoadingVisuals = createSelector(
  featureSelector,
  state => state.loadingVisuals
);

export const isCopyingVisual = createSelector(
  featureSelector,
  state => state.copyingVisual
);

export const isDeletingVisual = createSelector(
  featureSelector,
  state => state.deletingVisual
);

export const isSharingVisual = createSelector(
  featureSelector,
  state => state.sharingVisual
);

export const isTogglingVisualLibrary = createSelector(
  featureSelector,
  state => state.togglingVisualLibrary
);

export const isTogglingVisualIsSample = createSelector(
  featureSelector,
  state => state.togglingVisualIsSample
);

export const isDeletingSampleForUser = createSelector(
  featureSelector,
  state => state.deletingSampleForUser
);


export const getVisuals = createSelector(
  featureSelector,
  state => state.visuals
);

export const getSelectedVisualIds = createSelector(
  featureSelector,
  state => state.selectedVisualIds
);

export const getDisplayParams = createSelector(
  featureSelector,
  state => state.displayParams
);

export const expiringCache = createSelector(
  featureSelector,
  state => state.expiringCache
);
